import { GRID_UNIT_PX, ROOM_COLOR_MAPPING } from '@/constants';
import { uncapitalizeFirstLetter } from '@/utilities';

const roomCount = {};

function increaseRoomCount(type) {
  if (!roomCount[type]) {
    roomCount[type] = 0;
  }
  roomCount[type] += 1;
  return roomCount[type];
}

export default class Room {
  constructor({
    x, y, width, height, type, groupManager,
  }) {
    this.color = ROOM_COLOR_MAPPING[type];
    this.name = `${type} #${increaseRoomCount(type)}`;
    this.canvasConfig = {
      group: {
        x,
        y,
        width,
        height,
      },
      rect: {
        width,
        height,
        fill: this.color,
      },
      text: {
        x: width < 100 ? -25 : 0,
        y: 0,
        width: Math.max(120, width),
        height,
        fill: '#000',
        padding: 5,
      },
    };

    this.type = type;
    this.cornersCoord = {
      topLeft: [x, y],
      topRight: [x + width, y],
      bottomLeft: [x, y + height],
      bottomRight: [x + width, y + height],
    };
    this.taskDeliverCoord = this.cornersCoord.bottomLeft;
    this.taskReceiveCoord = this.cornersCoord.topRight;
    this.memberEnterCoord = this.cornersCoord.topLeft;
    this.memberExitCoord = this.cornersCoord.bottomRight;

    this.memberList = [];
    this.maxCapacity = (width / GRID_UNIT_PX) * (height / GRID_UNIT_PX);

    this.pathToOtherRooms = {};
    this.groupManager = groupManager;

    this.skills = {};
  }

  addSkill(skillInstance) {
    this.skills[uncapitalizeFirstLetter(skillInstance.constructor.name)] = skillInstance;
  }

  get memberCount() {
    return this.memberList.length;
  }

  processByTick() {
    this.memberList.filter((m) => m).forEach((employee) => {
      employee.processByTick();
    });
  }

  getCoordInRoom(memberIndex) {
    return [
      (Math.floor(memberIndex % (this.canvasConfig.rect.width / GRID_UNIT_PX)) + 1)
        * GRID_UNIT_PX - (GRID_UNIT_PX / 2) + this.canvasConfig.group.x,
      (Math.floor(memberIndex / (this.canvasConfig.rect.width / GRID_UNIT_PX)) + 1)
        * GRID_UNIT_PX - (GRID_UNIT_PX / 2) + this.canvasConfig.group.y,
    ];
  }

  getPathToCorners(memberIndex) {
    const memberCoord = this.getCoordInRoom(memberIndex);
    return {
      toTopLeft:
        this.groupManager.pathManager.getStraightPath(memberCoord, this.cornersCoord.topLeft),
      toTopRight:
        this.groupManager.pathManager.getStraightPath(memberCoord, this.cornersCoord.topRight),
      toBottomLeft:
        this.groupManager.pathManager.getStraightPath(memberCoord, this.cornersCoord.bottomLeft),
      toBottomRight:
        this.groupManager.pathManager.getStraightPath(memberCoord, this.cornersCoord.bottomRight),
    };
  }

  getMemberPathToOtherRoom(room) {
    let path = this.pathToOtherRooms[room.name];
    if (!path) {
      path = this.groupManager.pathManager.getGridPath(this.memberExitCoord, room.memberEnterCoord);
      this.pathToOtherRooms[room.name] = path;
    }
    return path;
  }

  updatePathToOtherRooms(roomName, path) {
    this.pathToOtherRooms[roomName] = path;
  }
}
